<template>
  <div class="col-xs-12 top-document" data-toggle="collapse" :data-target="'#collapse-'+ document.documentID" aria-expanded="false" :aria-controls="'collapse-'+ document.documentID">
    <table class="" style="width: 100%">
      <tr :class="{selected: document.biblio}">
        <td class="col-md-5" style="vertical-align: top" v-html="document.title"></td>

        <td class="col-md-4 " style="vertical-align: top" >
              <span class="coAuthors-divider"  v-for="(author, key) in document.co_authors" :key="key">
                {{ author.lastName }} {{ author.firstName }}
              </span>
        </td>
        <td class="col-md-2 text-center" style="vertical-align: middle" >
          {{document.pubDate | moment('Y')}}
        </td>
        <td class="col-md-1 text-center" style="vertical-align: center">
          <dropdown-document v-model="document" :context="context"></dropdown-document>
        </td>

      </tr>
    </table>

    <div style="bottom: -9px;position: absolute;width: 100%">
      <span style="margin-left: 49%;background-color: white;">
        <button style="border-radius: 50px;font-size: 0.6rem;" class="btn btn-info btn-xs">
        <i class="fa fa-chevron-down"></i>
        </button>
      </span>
    </div>
  </div>
</template>

<style scoped>

  .coAuthors-divider + .coAuthors-divider:before {
    content: ", ";
  }

  .is-table-row {
    display: table;
  }
  .is-table-row [class*="col-"] {
    float: none;
    display: table-cell;
    vertical-align: top;
  }

  .selected {
    border-left: 5px solid #3498db;
  }

  .dropdown-menu {
    min-width: 50px;
  }
  div > .dropdown > i {
    cursor: pointer;
  }

  .dropdown-expert-action > ul > li i{
    font-weight: bold;
    margin-right: 5px;
  }

  .dropdown-expert-action ul > li a{
    font-size: 12px;
  }

  .dropdown-expert-action ul > li{
    margin-bottom: 5px;
    font-size: 12px;
  }

  .top-document {
    cursor: pointer;
    /*max-height: 80px;*/
    padding: 15px 0;
    border-bottom: 1px solid #eaeaea;
  }
  .top-document:hover {
    background: #f5f5f5;
  }

</style>
<style>
  .br-theme-bars-horizontal .br-widget {
    height: auto;
    margin: auto;
  }

  .br-theme-bars-horizontal .br-widget a {
    height: 10px;
    background-color: rgba(0, 123, 225, 0.3);

  }

  .br-theme-bars-horizontal .br-widget a.br-active, .br-theme-bars-horizontal .br-widget a.br-selected {
    background-color: #007bff;
  }

  .br-theme-bars-horizontal .br-widget a, .br-theme-bars-horizontal .br-widget {
    width: 25px;
  }
</style>
<script>
import DropdownDocument from './DropdownDocument'

export default {
  components: {DropdownDocument},
  name: 'DocumentTop',
  props: ['value', 'context'],
  watch: {
    value: function (val) {
      console.log('documentTop update document', val)
      this.document = val
    },
    document: function (val, oldVal) {
      if (oldVal !== null) {
        this.$emit('input', val)
      }
    }
  },
  data () {
    return {
      document: null,
      listId: null
    }
  },
  methods: {
    initScore: (author) => {
      let score = 0
      if (author.score <= 0.1) {
        score = 1
      } else if (author.score < 0.5) {
        score = 2
      } else {
        score = 3
      }
      let scoreElement = $('#score-' + author.authorID)

      scoreElement.barrating({
        theme: 'bars-horizontal',
        readonly: true,
        showSelectedRating: false,
        hoverState: false,
        reverse: true,
        initialRating: score
      })
    }
  },
  beforeMount () {
    this.document = this.value
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/DocumentTop.vue